import { collection, getDocs, query, where } from "firebase/firestore";
import { getLocalStorageItem } from "../../../controllers/localStorage/getLocalStorage";
import { db } from "../../../firebase";

const getAllLeadsInCampaign = async (leadIds) => {
  try {
    const leadsCollection = await collection(db, "leads");

    let q = query(
      leadsCollection,
      where("bid", "==", getLocalStorageItem("bid"))
    );

    const leadsSnapshot = await getDocs(q);

    let leadsData = [];
    leadsSnapshot.docs.forEach((doc) => {
      if (leadIds.includes(doc.id)) {
        leadsData.push({
          id: doc.id,
          ...doc.data(),
        });
      }
    });
    return leadsData;
  } catch (error) {
    console.log(error);
  }
};

export default getAllLeadsInCampaign;
